export default class Address {

    modalText = {
        add: {
            title: 'Nuovo indirizzo',
        },
        modify: {
            title: 'Modifica indirizzo',
        },
        delete: {
            title: 'Elimina indirizzo',
            description: 'Vuoi eliminare il seguente indirizzo:'
        }
    }

    constructor (container, prefix = 'address_', required = false) {

        this.container = container;
        this.prefix = prefix;
        this.required = required;

        if (this.container.querySelector('input[name="'+this.prefix+'id"]')) {
            this.id = this.container.querySelector('input[name="'+this.prefix+'id"]');
        }

        this.name = this.container.querySelector('input[name="'+this.prefix+'name"]');
        this.surname = this.container.querySelector('input[name="'+this.prefix+'surname"]');

        this.country = this.container.querySelector('select[name="'+this.prefix+'country"]');
        this.province = this.container.querySelector('select[name="'+this.prefix+'province"]');
        this.cap = this.container.querySelector('input[name="'+this.prefix+'cap"]');
        this.city = this.container.querySelector('input[name="'+this.prefix+'city"]');
        this.street = this.container.querySelector('input[name="'+this.prefix+'street"]');
        this.number = this.container.querySelector('input[name="'+this.prefix+'number"]');

        this.phonePrefix = this.container.querySelector('select[name="'+this.prefix+'phone_prefix"]');
        this.phone = this.container.querySelector('input[name="'+this.prefix+'phone"]');

        if (this.container.querySelector('input[name="'+this.prefix+'more"]')) {
            this.more = this.container.querySelector('input[name="'+this.prefix+'more"]');
        }

    }

    setForm(data) {

        this.id.value = data.id;
        
        this.name.value = data.name;
        this.surname.value = data.surname;

        this.cap.value = data.cap;
        this.city.value = data.city;
        this.street.value = data.street;
        this.number.value = data.number;
        this.phone.value = data.phone;

        // select2 element
        $(this.country).val(data.country).trigger('change');
        delay(500).then(() => { $(this.province).val(data.province).trigger('change'); });
        $(this.phonePrefix).val(data.phonePrefix).trigger('change');

        this.initForm();

    }

    initForm() {
        
        if (this.required) { 

            setRequired(this.name, true);
            setRequired(this.surname, true);
    
            setRequired(this.country, true);
            setRequired(this.province, true);
            setRequired(this.cap, true);
            setRequired(this.city, true);
            setRequired(this.street, true);
            setRequired(this.number, true);
            
        }

        this.name.disabled = false;
        this.surname.disabled = false;

        this.phonePrefix.disabled = false;
        this.phone.disabled = false;

        this.country.disabled = false;
        this.province.disabled = false;
        this.cap.disabled = false;
        this.city.disabled = false;
        this.street.disabled = false;
        this.number.disabled = false;

        if (this.more) {
            this.more.disabled = false;
        }

        check();

    }

    resetForm(disable = false) {

        this.container.querySelectorAll('input, select').forEach(element => {
            
            var prefix = element.name.substring(0, this.prefix.length);

            if (prefix == this.prefix) {

                if (element.name == this.prefix+'country') {
                    $(element).val('IT').trigger('change');
                } else if (element.name == this.prefix+'phone_prefix') {
                    $(element).val('+39').trigger('change');
                } else {
                    element.value = '';
                }

                setRequired(element, false);

                if (disable) { element.disabled = true; }


            }

        });

        check();

    }

    modalDelete(id, text) {

        var modalEl = document.querySelector('#'+this.prefix+'modal-delete');

        modalEl.querySelector('input[name="'+this.prefix+'delete-id"]').value = id;
        modalEl.querySelector('.modal-title').innerHTML = this.modalText.delete.title;
        modalEl.querySelector('.modal-body .value').innerHTML = this.modalText.delete.description+'<br>'+text;

        new bootstrap.Modal(modalEl).show();

    }

    modalForm(type = 'modify') {

        var modalTitle;

        var modalEl = document.querySelector('#'+this.prefix+'modal-form');
        new bootstrap.Modal(modalEl).show();

        if (type == 'modify') {
            modalTitle = this.modalText.modify.title;
        } else if (type == 'add') {
            modalTitle = this.modalText.add.title;
        }

        modalEl.querySelector('.modal-title').innerHTML = modalTitle

        modalEl.addEventListener('hidden.bs.modal',() => { this.resetForm(true); })

    }

}